import { render, staticRenderFns } from "./GameResultLinks.vue?vue&type=template&id=b5468dd0&scoped=true&"
import script from "./GameResultLinks.vue?vue&type=script&lang=js&"
export * from "./GameResultLinks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5468dd0",
  null
  
)

export default component.exports